/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import PresentationView from './views/Presentation';
import BatchFix from 'views/PVE/BatchFix/BatchFix';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/auth/login" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('views/Login'))
      },
      {
        path: '/auth/register',
        exact: true,
        component: lazy(() => import('views/Register'))
      },
      {
        path: '/auth/logout',
        exact: true,
        component: lazy(() => import('views/Logout'))
      },

      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      // {
      //   path: '/fabric/users',
      //   exact: true,
      //   auth:["ADMIN"],
      //   component: lazy(() => import('views/Fabric/User/UserList'))
      // },
      // {
      //   path: '/fabric/users/create',
      //   exact: true,
      //   auth:["ADMIN"],
      //   component: lazy(() => import('views/Fabric/User/UserCreate'))
      // },
      // {
      //   path: '/fabric/user/:name/edit',
      //   exact: true,
      //   auth:["ADMIN"],
      //   component: lazy(() => import('views/Fabric/User/UserEdit'))
      // },
      // {
      //   path: '/fabric/user/:name',
      //   exact: true,
      //   auth:["ADMIN"],
      //   component: lazy(() => import('views/Fabric/User/UserInfo'))
      // },
      // {
      //   path: '/fabric/transfer',
      //   exact: true,
      //   auth: ["ADMIN"],
      //   component: lazy(() => import('views/Fabric/User/Transfer'))
      // },
      // {
      //   path: '/fabric/recycle',
      //   exact: true,
      //   auth: ["ADMIN"],
      //   component: lazy(() => import('views/Fabric/User/Recycle'))
      // },
      // {
      //   path: '/fabric/votes',
      //   exact: true,
      //   auth: ["ADMIN"],
      //   component: lazy(() => import('views/Fabric/Vote/VoteList2'))
      // },
      // {
      //   path: '/fabric/vote/create',
      //   exact: true,
      //   auth: ["ADMIN"],
      //   component: lazy(() => import('views/Fabric/Vote/VoteCreate'))
      // },
      // {
      //   path: '/fabric/vote/:subject',
      //   exact: true,
      //   auth: ["ADMIN"],
      //   component: lazy(() => import('views/Fabric/Vote/VoteDetails'))
      // },
      // {
      //   path: '/fabric/network',
      //   exact: true,
      //   auth: ["ADMIN"],
      //   component: () => {
      //     window.location.href = "http://localhost:9999"
      //     // window.open("http://localhost:9999")
      //   }
      // },

      {
        path: '/admin/users',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/User/UserList'))
      },
      {
        path: '/admin/users/create',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/User/UserCreate'))
      },
      {
        path: '/admin/user/:phone/edit',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/User/UserEdit'))
      },
      {
        path: '/admin/user/:phone',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/User/UserInfo'))
      },
      {
        path: '/admin/steamtoken',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/SteamToken'))
      },
      {
        path: '/admin/serverwatch',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/ServerStatus'))
      },
      {
        path: '/admin/shortcut',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/OtherSetting'))
      },
      {
        path: '/pay/orders',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Pay'))
      },
      {
        path:'/admin/systemlogs',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/SystemLogs'))
      },
      {
        path: '/pay/paypal',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Pay/Paypal/Paypal'))
      },
      {
        path: '/atomicwar/activeCode',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/ActiveCode'))
      },
      {
        path: '/atomicwar/steamplayers',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/AtomicWar/SteamPlayer/PlayerList'))
      },
      {
        path: '/atomicwar/steamplayer/:id',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/AtomicWar/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/atomicwar/steamplayer/:id/:tab',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/AtomicWar/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/atomicwar/recharge/statis',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/Recharge/Statistias'))
      },
      {
        path: '/atomicwar/recharge/ordercreate',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/Recharge/OrderCreate'))
      },
      {
        path: '/atomicwar/leaderboard/top100',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/AtomicWar/Leaderboard/Top100'))
      },
      {
        path: '/atomicwar/leaderboard/leveldetail',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/Leaderboard/LevelDetail'))
      },
      {
        path: '/atomicwar/statis/player',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/AtomicWar/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/atomicwar/bannedhero',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/BannedHero'))
      },
      {
        path: '/atomicwar/blacklist',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/BlackList/getBlackList'))
      },
      {
        path: '/atomicwar/blacklist/createBlackList',
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/BlackList/createBlackList'))
      },
      {
        path: '/atomicwar/recharge/retrive',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/Recharge/Retrive'))
      },
      {
        path: '/atomicwar/shopTicket',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/ShopTicket'))
      },
      {
        path: '/atomicwar/statis/dailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/CrStatistics/DailyReport'))
      },
      {
        path: '/atomicwar/statis/shopdailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/CrStatistics/ShopDailyReport'))
      },
      {
        path: '/atomicwar/batchfix',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/BatchFix'))
      },
      {
        path:'/atomicwar/ipstatis',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/Recharge/IpStatis'))
      },
      {
        path:'/atomicwar/clientip',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/AtomicWar/ClientIp'))
      },

      {
        path: '/atomicwar/pay',
        exact: true,
        auth:["ADMIN"],
        component: lazy(() => import('views/AtomicWar/Shop'))
      },
 
      {
        path: '/atomicwar/pay/:tab',
        exact: true,
        component: lazy(() => import('views/AtomicWar/Shop'))
      },
      //pve
      {
        path: '/ymmj/steamtoken',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/SteamToken'))
      },
      {
        path: '/ymmj/activeCode',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/ActiveCode'))
      },
      {
        path: '/ymmj/steamplayers',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/SteamPlayer/PlayerList'))
      },
      {
        path: '/ymmj/testingplayers',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/TestingPlayerList'))
      },
      {
        path: '/ymmj/steamplayer/:id',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/ymmj/steamplayer/:id/:tab',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/ymmj/recharge/statis',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/Recharge/Statistias'))
      },
      {
        path: '/ymmj/recharge/ordercreate',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/Recharge/OrderCreate'))
      },
      {
        path: '/ymmj/leaderboard/top100',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/Leaderboard/Top100'))
      },
      {
        path: '/ymmj/leaderboard/season',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/Leaderboard/SeasonRank'))
      },
      {
        path: '/ymmj/leaderboard/leveldetail',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/Leaderboard/LevelDetail'))
      },
      {
        path: '/ymmj/statis/player',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/ymmj/bannedhero',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/BannedHero'))
      },
      {
        path: '/ymmj/specialusers',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/SpecialList/geSpecialList'))
      },
      {
        path: '/ymmj/specialusers/create',
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/SpecialList/createSpecialList'))
      },
      {
        path: '/ymmj/blacklist',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/BlackList/getBlackList'))
      },
      {
        path: '/ymmj/blacklist/createBlackList',
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/BlackList/createBlackList'))
      },
      {
        path: '/ymmj/recharge/retrive',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/Recharge/Retrive'))
      },
      {
        path: '/ymmj/shopTicket',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/ShopTicket'))
      },
      {
        path: '/ymmj/statis/dailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/CrStatistics/DailyReport'))
      },
      {
        path: '/ymmj/statis/shopdailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/CrStatistics/ShopDailyReport'))
      },
      {
        path: '/ymmj/statistics/match',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/PVE/CrStatistics/MatchStatistics'))
      },
      {
        path: '/ymmj/statistics/api',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/CrStatistics/ApiStatistics'))
      },
      {
        path: '/ymmj/batchfix',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/PVE/BatchFix'))
      },
      //lordward
      {
        path: '/lw/steamtoken',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/SteamToken'))
      },
      {
        path: '/lw/activeCode',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/ActiveCode'))
      },
      {
        path: '/lw/steamplayers',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/LordWar/SteamPlayer/PlayerList'))
      },
      {
        path: '/lw/testingplayers',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/TestingPlayerList'))
      },
      {
        path: '/lw/steamplayer/:id',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/LordWar/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/lw/steamplayer/:id/:tab',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/LordWar/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/lw/recharge/statis',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/Recharge/Statistias'))
      },
      {
        path: '/lw/recharge/ordercreate',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/Recharge/OrderCreate'))
      },
      {
        path: '/lw/leaderboard/top100',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/LordWar/Leaderboard/Top100'))
      }, 
      {
        path: '/lw/statis/player',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/LordWar/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/lw/bannedhero',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/BannedHero'))
      },
      {
        path: '/lw/specialusers',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/SpecialList/geSpecialList'))
      },
      {
        path: '/lw/specialusers/create',
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/SpecialList/createSpecialList'))
      }, 
      {
        path: '/lw/recharge/retrive',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/Recharge/Retrive'))
      },
      {
        path: '/lw/shopTicket',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/ShopTicket'))
      },
      {
        path: '/lw/statis/dailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/CrStatistics/DailyReport'))
      },
      {
        path: '/lw/statis/shopdailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/CrStatistics/ShopDailyReport'))
      },
 
      {
        path: '/lw/batchfix',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/LordWar/BatchFix'))
      },
      //party
      {
        path: '/party/admin/steamtoken',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/SteamToken'))
      },
      {
        path: '/party/admin/activeCode',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/ActiveCode'))
      },
      {
        path: '/party/admin/steamplayers',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Party/SteamPlayer/PlayerList'))
      }, 
      {
        path: '/party/admin/steamplayer/:id',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Party/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/party/admin/steamplayer/:id/:tab',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Party/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/party/recharge/statis',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/Recharge/Statistias'))
      },
      {
        path: '/party/admin/recharge/ordercreate',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/Recharge/OrderCreate'))
      },
      {
        path: '/party/leaderboard/top100',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Party/Leaderboard/Top100'))
      },
      {
        path: '/party/leaderboard/season',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Party/Leaderboard/SeasonRank'))
      },
      {
        path: '/party/leaderboard/detail',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/Leaderboard/LevelDetail'))
      },
      {
        path: '/party/admin/statis/player',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Party/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/party/admin/bannedhero',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/BannedHero'))
      }, 
      {
        path: '/party/recharge/retrive',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/Recharge/Retrive'))
      },
      {
        path: '/party/admin/shopTicket',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/ShopTicket'))
      },
      {
        path: '/party/cr/statis/dailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/CrStatistics/DailyReport'))
      },
      {
        path: '/party/cr/statis/shopdailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Party/CrStatistics/ShopDailyReport'))
      },
      // {
      //   path: '/party/cr/statistics/match',
      //   exact: true,
      //   auth: ["ADMIN", "Service"],
      //   component: lazy(() => import('views/Party/CrStatistics/MatchStatistics'))
      // },
      {
        path: '/lw/shop',
        exact: true,
        auth:["ADMIN"],
        component: lazy(() => import('views/LordWar/Shop'))
      },
      {
        path: '/lw/shop/:tab',
        exact: true,
        component: lazy(() => import('views/LordWar/Shop'))
      },
      {
        path: '/lw/order/:id/detail',
        exact: true,
        component: lazy(() => import('views/LordWar/Shop/OrderDetail'))
      },
      {
        path: '/bb/steamplayers',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/BeatingBox/SteamPlayer/PlayerList'))
      },
       {
        path: '/bb/steamplayer/:id',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/BeatingBox/SteamPlayer/PlayerDetails'))
      },
       {
        path: '/bb/steamplayer/:id/:tab',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/BeatingBox/SteamPlayer/PlayerDetails'))
      },
        {
        path: '/bb/leaderboard',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/BeatingBox/Leaderboard/Top100'))
      },
       {
        path: '/bb/storagestatus',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/BeatingBox/StorageStatus'))
      },
       {
        path: '/luckydefence/steamplayers',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Luckydefence/SteamPlayer/PlayerList'))
      },
      {
        path: '/luckydefence/steamplayer/:id',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Luckydefence/SteamPlayer/PlayerDetails'))
      },
       {
        path: '/luckydefence/steamplayer/:id/:tab',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Luckydefence/SteamPlayer/PlayerDetails'))
      },
      {
        path: '/luckydefence/shopTicket',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Luckydefence/ShopTicket'))
      },
      {
        path: '/luckydefence/mail',
        exact: true,
        auth: ["ADMIN", "Service"],
        component: lazy(() => import('views/Luckydefence/Mail'))
      },
       {
        path: '/luckydefence/dailyreport',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Luckydefence/CrStatistics/DailyReport'))
      },
       {
        path: '/luckydefence/recentlyrecharge',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Luckydefence/Recharge/Statistias'))
      },
      {
        path: '/luckydefence/batchfix',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Luckydefence/BatchFix'))
      },
       {
        path: '/luckydefence/activecode',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Luckydefence/ActiveCode'))
      },
       {
        path: '/luckydefence/leaderboard1',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Luckydefence/Leaderboard/SeasonRank'))
      },
      {
        path: '/admin/todo',
        exact: true,
        component: lazy(() => import('views/ToDo/ToDoList'))
      },
      {
        path: '/admin/todo/todoCreate',
        exact: true,
        component: lazy(() => import('views/ToDo/ToDoCreate'))
      },
      {
        path: '/calendar',
        exact: true,
        auth: ["SUPER"],
        component: lazy(() => import('views/Calendar'))
      },
      {
        path: '/changelog',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Changelog'))
      },
      {
        path: '/chat',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Chat'))
      },
      {
        path: '/chat/:id',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Chat'))
      },
      {
        path: '/dashboards/analytics',
        exact: true,
        auth: ["ADMIN"],
        component: DashboardAnalyticsView
      },
      {
        path: '/dashboards/default',
        exact: true,
        auth: ["ADMIN"],
        component: DashboardDefaultView
      },
      {
        path: '/invoices/:id',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/InvoiceDetails'))
      },
      {
        path: '/kanban-board',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/KanbanBoard'))
      },
      {
        path: '/mail',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Mail'))
      },
      {
        path: '/management/customers',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/CustomerManagementList'))
      },
      {
        path: '/management/customers/:id',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/CustomerManagementDetails'))
      },
      {
        path: '/management/customers/:id/:tab',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/CustomerManagementDetails'))
      },
      {
        path: '/management/projects',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/ProjectManagementList'))
      },
      {
        path: '/management/orders',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/OrderManagementList'))
      },
      {
        path: '/management/orders/:id',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/OrderManagementDetails'))
      },
      {
        path: '/overview',
        exact: true,
        auth: ["ADMIN"],
        component: OverviewView,
      },
      {
        path: '/presentation',
        exact: true,
        auth: ["GUEST", "Service"],
        component: PresentationView
      },
      {
        path: '/profile/:id',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Profile'))
      },

      {
        path: '/profile/:id/:tab',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Profile'))
      },
      {
        path: '/projects/create',
        exact: true,
        component: lazy(() => import('views/ProjectCreate'))
      },
      {
        path: '/projects/:id',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/ProjectDetails'))
      },
      {
        path: '/projects/:id/:tab',
        exact: true,
        component: lazy(() => import('views/ProjectDetails'))
      },
      {
        path: '/projects',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/ProjectList'))
      },
      {
        path: '/settings',
        exact: true,
        auth: ["ADMIN"],
        component: lazy(() => import('views/Settings'))
      },
      {
        path: '/settings/:tab',
        exact: true,
        auth: ["SUPER"],
        component: lazy(() => import('views/Settings'))
      },
      {
        path: '/social-feed',
        exact: true,
        auth: ["SUPER"],
        component: lazy(() => import('views/SocialFeed'))
      },
      {
        path: '/getting-started',
        exact: true,
        auth: ["SUPER"],
        component: lazy(() => import('views/GettingStarted'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
